import {
  ApiEventItem,
  EventRoleFlags,
  EventSourceEntry,
  EventSummary,
  ListingRole,
  MyEventItem,
} from 'src/app/types/event-access.types';

function summaryFromApiEvent(event: ApiEventItem): EventSummary {
  return {
    id: event.id,
    name: event.name,
    slug: event.slug ?? null,
    initialDate: event.initial_date,
    finishDate: event.finish_date,
    coverImage: event.cover_image ?? null,
    businessName: event.business ?? null,
  };
}

function entryFromApiEvent(event: ApiEventItem, flags: Partial<EventRoleFlags>): EventSourceEntry {
  return { event: summaryFromApiEvent(event), flags, capabilities: null };
}

/** `GET /api/seller-app/my-events`: vender y reporte global salen de `capabilities`. */
export function fromMyEvent(item: MyEventItem): EventSourceEntry {
  return {
    event: {
      id: item.id,
      name: item.name,
      slug: item.slug ?? null,
      initialDate: item.initial_date,
      finishDate: item.finish_date,
      coverImage: item.cover_image ?? null,
      businessName: item.business?.name ?? null,
    },
    flags: {
      canSell: item.capabilities.can_sell,
      canViewGlobalReport: item.capabilities.can_view_global_report,
    },
    capabilities: item.capabilities,
  };
}

/** `/sales-manager/events*?role=...`: el rol pedido es el que habilita el evento. */
export function fromSalesManagerEvent(event: ApiEventItem, role: ListingRole): EventSourceEntry {
  const flags: Partial<EventRoleFlags> = role === 'administrator' ? { isAdminEvent: true } : { isBossEvent: true };
  return entryFromApiEvent(event, flags);
}

/** `/seller-app/events/past|inactive`: solo trae eventos con productos asignados. */
export function fromSellerAppEvent(event: ApiEventItem): EventSourceEntry {
  return entryFromApiEvent(event, { canSell: true });
}

/** `/sellers/events-past|events-inactive?with_permissions=true`: solo aporta el reporte global. */
export function fromSellersPermissionEvent(event: ApiEventItem): EventSourceEntry {
  return entryFromApiEvent(event, event.global_report === true ? { canViewGlobalReport: true } : {});
}
